export const getMarker = (color) => {
    const defaultColor = "#012a60";
    if (!color) {
        color = defaultColor;
    }
    color = color.replace("#", "%23");
    return `data:image/svg+xml;charset=utf8,%3Csvg width='10' height='10' xmlns='http://www.w3.org/2000/svg'%3E%3Cg%3E%3Ctitle%3ELayer 1%3C/title%3E%3Cellipse stroke='%23fff' ry='5.28889' rx='5.41481' id='svg_1' cy='4.98518' cx='5.01111' fill='${color}'/%3E%3C/g%3E%3C/svg%3E`;
}

export const getDefaultMarker = () => {
    return `data:image/svg+xml;charset=utf8,%3Csvg width='10' height='10' xmlns='http://www.w3.org/2000/svg'%3E%3Cg%3E%3Ctitle%3ELayer 1%3C/title%3E%3Cellipse stroke='%23fff' ry='5.28889' rx='5.41481' id='svg_1' cy='4.98518' cx='5.01111' fill='%23012a60'/%3E%3C/g%3E%3C/svg%3E`;
}

export const getActiveMarker = () => {
    return "data:image/svg+xml;charset=utf8,%3Csvg width='10' height='10' xmlns='http://www.w3.org/2000/svg'%3E%3Cg%3E%3Ctitle%3ELayer 1%3C/title%3E%3Cellipse stroke='%23fff' ry='5.28889' rx='5.41481' id='svg_1' cy='4.98518' cx='5.01111' fill='%23fdb913'/%3E%3C/g%3E%3C/svg%3E";
}

export const getAveragePosition = (latOrLngArray) => {
    let average;

    latOrLngArray.sort((a, b) => a - b);
    if (latOrLngArray.length === 1) {
        average = latOrLngArray[0];
    } else {
        average = latOrLngArray[Math.ceil(latOrLngArray.length / 2)];
    }

    return average;
}
